import React from 'react'
import classNames from 'classnames'

export default function Badge({ children, style }) {
    return (
        <p
            className={classNames(
                'position-absolute',
                'bg-primary',
                'text-white',
                'text-center',
                'text-nowrap',
                'shadow',
                'mb-0',
            )}
            style={{
                fontSize: 14,
                fontWeight: 800,
                paddingBlock: 2,
                paddingInline: 12,
                ...style,                
            }}
        >
            {children}
        </p>
    )
}
